import { render, staticRenderFns } from "./dealerLog.vue?vue&type=template&id=2092264c&scoped=true"
import script from "./dealerLog.vue?vue&type=script&lang=js"
export * from "./dealerLog.vue?vue&type=script&lang=js"
import style0 from "./dealerLog.vue?vue&type=style&index=0&id=2092264c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2092264c",
  null
  
)

export default component.exports